module.exports = __webpack_public_path__ + "img/backarrow.90cdacf9.svg";